import {
    VALENTINE_EVENT_DELIVERY_PROMISE,
    XMAS_EVENT_DELIVERY_PROMISE,
} from '@client/config/constants';
import { Campaign } from '@shared/types/mylounge';

export const useDeliveryLabel = (campaign: Campaign) => {
    const isSpecialDeliveryBanner = [
        XMAS_EVENT_DELIVERY_PROMISE,
        VALENTINE_EVENT_DELIVERY_PROMISE,
    ].includes(campaign?.deliveryPromise?.type);

    const showDeliveryLabel = Boolean(
        !isSpecialDeliveryBanner &&
            campaign?.deliveryPromise?.text &&
            campaign?.deliveryPromise?.type,
    );

    return { isSpecialDeliveryBanner, showDeliveryLabel };
};
